import { style } from './chart-tooltip.module.css';

interface Props {
  active?: boolean;
  payload?: {
    color?: string;
    name?: string;
    value?: any;
    payload?: any;
    fill?: string;
  }[];
  label?: string;
  formatLabel: (label: any) => string;
  formatValue: (value: any) => string;
}

export function ChartTooltip(props: Props) {

  const {
    active,
    payload = [],
    label,
    formatLabel,
    formatValue
  } = props;

  const items = Array.from(payload)
    .filter(item => item && item.value !== undefined && item.value !== null)
    .sort((a, b) => b.value - a.value);

  if (!active || !payload || !payload?.length) {
    return null;
  }

  return (
    <div className={style.container}>
      <div className={style.label}>{formatLabel(label)}</div>
      <div className={style.items}>
        {items.map((item: any, index: number) => (
          <div key={index} className={style.item}>
            <div className={style.dot} style={{ backgroundColor: item.color || item.payload?.fill || item.fill }}/>
            <span className={style.name}>{item.name}</span>
            <span className={style.value}>{formatValue(item.value)}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
